define([], function() {
  
    var checkDependencies = function(dependencies) {
        var dependenciesAvailable = dependencies.reduce(function(value, item){
            return (typeof window[item] !== 'undefined') && value;    
        }, true);  
        return dependenciesAvailable       
    }             
    
                          
    var wait = function(response, options, callback, execOptions){ 
        var interval = execOptions.interval,
            timeout = execOptions.timeout,  
            startTime = new Date().getTime();  
        var tryResponse = function(onTry){
            try{
                response(options, onTry)
            }   
            catch(e){
                onTry(e)
            }            
        }       
        var responseCallback = function(error, result){
            if(error){
                if(interval > 0 && timeout > 0){
                    var delta = new Date().getTime() - startTime;
                    if(delta < timeout){
                        //execute again later
                        setTimeout(tryResponse, interval, responseCallback);
                    }
                    else{
                        callback(new Error("Response Timeout"));
                    }
                }
                else{
                    callback(error);
                }
            }
            else{
                callback(null, result)
            }
        }
        tryResponse(responseCallback);
    };
    
    var delayAndWait = function(response, options, callback, execOptions){
        var delay = execOptions.delay, 
            dependencies = execOptions.dependencies,
            action = response
        if(dependencies && dependencies.length > 0){
            action = function(options, callback) {
                var dependenciesAvailable = checkDependencies(dependencies);
                if(dependenciesAvailable){
                    response(options, callback)
                }
                else{
                    callback(new Error("Dependencies not available"))
                }
            }
        }
        if(delay && delay > 0){
            setTimeout(function(){
                wait(action, options, callback, execOptions);
            }, delay);    
        }
        else{
            wait(action, options, callback, execOptions);
        }
    };
    
    return delayAndWait;
});


//////////////////
// WEBPACK FOOTER
// ./utils/delayAndWait.js
// module id = 46
// module chunks = 0